import { useState } from "react";
import TransferPresenter from "./TransferPresenter";
import { useAuth } from "components/Auth";
import { notify } from "components/atoms/notification/Notification";
import useMutationButton from "components/atoms/buttons/useMutationButton";
import { checkPassword } from "api/authAPI";
import { useAppSelector } from "redux/hooks";
import useStatusMutation from "hook/useStatusMutation";
import { postAccountTransfer } from "api/accountAPI";
import * as s from "components/atoms/buttons/ButtonStyled";
import { Account } from "api/mappers/accountMapper";
import useApiError from "hook/useApiError";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import { handleDuplicateAccountName } from "utils/AccountUtil";
import { checkEmpty, toTrim } from "utils/functions";

export interface TransferData {
  accountId: string;
  email: string;
  password: string;
}

const initialTransferData: TransferData = {
  accountId: "",
  email: "",
  password: "",
};

interface Props {
  onModal: () => void;
  accountInfo: Account;
  onSuccessTransfer: () => void;
}
export default function TransferContainer(props: Props) {
  const auth = useAuth();
  const [dataTransfer, setDataTransfer] = useState<TransferData>({
    ...initialTransferData,
    email: auth.user?.email as string,
  });
  const selectAccount = useAppSelector((state) => state.accountSettings);
  const { handleErrorNotify, notifyError, notifySuccess, lang, intlString } =
    useApiError();
  const [validateMsg, setValidateMsg] = useState<ValidateMsg>({
    isAccountName: "",
  });

  const mutationTransferButtonProps = useStatusMutation(postAccountTransfer, {
    onSuccess: (res: any) => {
      if (res.error === 0) {
        notifySuccess(lang.validateMsg.account.transfer.success);
        props.onSuccessTransfer();
      } else {
        notifyError(lang.validateMsg.account.transfer.fail);
      }
    },
    onError: (e) => {
      if (e.response?.data.error === 3008) {
        handleDuplicateAccountName({
          setFn: setValidateMsg,
          validateKey: "isAccountName",
          elementId: "dw_account_input_account_name",
          message: intlString(lang.ServerErrorCode[3008]),
        });
        return;
      }
      handleErrorNotify(
        e,
        lang.validateMsg.account.transfer.fail,
        "validateMsg.account.transfer"
      );
    },
  });
  const mutationCheckPasswordButtonProps = useMutationButton({
    onClick: (mutate) => {
      if (checkEmpty(dataTransfer.accountId)) {
        notifyError(lang.validateMsg.account.name);
        return;
      }
      if (checkEmpty(dataTransfer.password)) {
        notifyError(lang.validateMsg.signup.password.empty);
        return;
      }
      mutate.mutate({
        payload: {
          email: toTrim(dataTransfer.email),
          password: toTrim(dataTransfer.password),
        },
      });
    },
    mutationFn: checkPassword,
    onSuccess: (res: any) => {
      if (res.result.isExist) {
        mutationTransferButtonProps.mutate({
          payload: {
            originalAccountId: selectAccount.accountId, //현재 내가 접속해 있는 accountId
            targetAccountId: props.accountInfo.accountId, //edit팝업의 accountId
            dstAccountNumber: dataTransfer.accountId, //transfer할 accountId(입력받은)
          },
        });
        return;
      }
      notifyError(lang.ServerErrorCode["1002"]);
    },
    onError: (e) => {
      handleErrorNotify(e, lang.ServerErrorCode["1002"]);
    },
    ButtonComponent: s.BigButton,
    disabled: !mutationTransferButtonProps.idle,
  });
  return (
    <TransferPresenter
      onClose={props.onModal}
      dataTransfer={dataTransfer}
      setDataTransfer={setDataTransfer}
      mutationCheckPasswordButtonProps={mutationCheckPasswordButtonProps}
      validateMsg={validateMsg}
    />
  );
}
